/**
 * RISK-FAMILIES-CONFIG
 * Gestion des familles de risques de l'organisation, depuis les échelles de risques
 */
import Card from "@/components/card"
import Link from "@/components/link"
import ListItem from "@/components/list-item"
import Space from "@/components/space"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import riskFamilyStore from "@/entities/risk-family/model/risk-family.store"
import { RiskFamily } from "@/entities/risk-family/model/risk-family.types"
import RiskFamilyEditModal from "@/entities/risk-family/ui/modal/RiskFamilyEditModal"
import { getRiskFamilyImageUrl } from "@/entities/risk-family/model/risk-family.utils"
import { faLayerGroup, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"

export default function RiskFamiliesConfig() {
  const dispatch = useAppDispatch()
  const families = useAppSelector(riskFamilyStore.selectors.list)
  const sortedFamilies = [...families].sort((a, b) => a.name.localeCompare(b.name))

  //State : famille en cours d'edition, ou "NEW" pour un ajout
  const [editedFamily, setEditedFamily] = useState<RiskFamily | "NEW" | null>(null)

  //Les familles ne sont chargees qu'a la connexion a un etablissement : cette page etant de niveau
  //compte, elle doit les demander elle-meme.
  useEffect(() => {
    dispatch(riskFamilyStore.thunks.fetchAndSet())
  }, [dispatch])

  return (
    <Card className="space-y-6">
      {editedFamily && (
        <RiskFamilyEditModal
          family={editedFamily === "NEW" ? undefined : editedFamily}
          onClose={() => setEditedFamily(null)}
          onDelete={() => setEditedFamily(null)}
        />
      )}

      <div className="mb-4 flex items-center gap-3">
        <FontAwesomeIcon icon={faLayerGroup} className="grey-t text-lg" />
        <span className="text-lg">Familles de risques</span>
        <Space />
        <Link icon={faPlus} isWithoutMargin onClick={() => setEditedFamily("NEW")}>
          Ajouter famille
        </Link>
      </div>

      {sortedFamilies.length === 0 ? (
        <div className="grey-t">Aucune famille de risques.</div>
      ) : (
        sortedFamilies.map((family) => {
          const imageUrl = getRiskFamilyImageUrl(family)

          return (
            <ListItem key={family.id} isSmall isEditable onClick={() => setEditedFamily(family)}>
              <div className="flex w-full items-center gap-20">
                <div className="flex h-[32px] w-[44px] shrink-0 items-center justify-center">
                  {imageUrl && (
                    <img
                      alt={family.name}
                      className="max-h-full max-w-full object-contain"
                      src={imageUrl}
                      onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                  )}
                </div>
                <div className="min-w-0 flex-1 truncate">{family.name}</div>
              </div>
            </ListItem>
          )
        })
      )}
    </Card>
  )
}
